// Only path-level URLs and controlled event fields reach analytics.
export function safePageUrl(value, origin = 'https://peacelovewellness.co') {
  try { const url = new URL(value || '/', origin); return `${url.origin}${url.pathname}`; } catch { return origin + '/'; }
}
export function safePageParameters(location, referrer = '') {
  return { page_path: location.pathname || '/',
    page_location: safePageUrl(location.pathname, location.origin),
    page_referrer: referrer ? safePageUrl(referrer, location.origin) : '' };
}
export function scrubLegacyMatchingUrl() {
  if (typeof window === 'undefined') return;
  const url = new URL(window.location.href);
  let changed = false;
  for (const key of ['gmContext', 'gmType', 'gmSource']) {
    if (url.searchParams.has(key)) { url.searchParams.delete(key); changed = true; }
  }
  if (changed) window.history.replaceState(window.history.state, '', `${url.pathname}${url.search}${url.hash}`);
}
export function safeEventParameters(eventName) {
  if (eventName === 'form_start' || eventName === 'form_submit') return { form_name: 'plwContact' };
  return {};
}
